import { type DashboardData } from '@/types';
import { makeRequestActionCreator } from '@/utils';
import { dashboardSlice } from './slice';

const createAction = makeRequestActionCreator(dashboardSlice.name);
const createRequestAction = makeRequestActionCreator(dashboardSlice.name);

export const tryFetchDashboardData = createAction('tryFetchDashboardData');

export const fetchDashboardData = createRequestAction<void, DashboardData>(
  'fetchDashboardData',
);

export const { setDashboardData } = dashboardSlice.actions;
